import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store'

import Login from '@/views/Login.vue'
import Default from '@/views/Default.vue'
import Home from '@/views/Home.vue'
import Interventi from '@/views/Interventi.vue'
import StoricoInterventi from '@/views/StoricoInterventi.vue'
import Scadenzario from '@/views/Scadenzario.vue'
import Entita from '@/views/Entita.vue'
import SchedaEntita from '@/views/SchedaEntita.vue'
import MyAccount from '@/views/MyAccount.vue'
import Contratti from '@/views/Contratti.vue'


const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/default',
    name: "Default",
    component: Default,    
    beforeEnter(to, from, next){
      if(store.getters.getUtente){
        next();
      }
      else{
        next('/');
      }
    },    
    children:[
      {
        path: '',
        name: "Home",
        component: Home,
        meta: {
          breadCrumbs:[
            {
              to: '/',
              text: 'Home'
            }
          ]
        },
      },
      {
        path: '/interventi',
        name: "Interventi",
        component: Interventi,   
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'Home'
            },
            {
              to: '',
              text: 'Interventi in Corso'
            }
          ]
        }       
      },
      {
        path: '/storico-interventi',
        name: "StoricoInterventi",
        component: StoricoInterventi,   
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'Home'
            },
            {
              to: '',
              text: 'Storico Interventi'
            }
          ]
        }       
      },
      {
        path: '/scadenzario',
        name: "Scadenzario",
        component: Scadenzario,   
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'Home'
            },
            {
              to: '',
              text: 'Scadenzario'
            }
          ]
        }       
      },
      {
        path: '/entita',
        name: "Entita",
        component: Entita,   
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'Home'
            },
            {
              to: '',
              text: 'Entita'
            }
          ]
        } 
      },
      {
        path: 'entita/:idEntita',
        name: 'SchedaEntita', 
        component: SchedaEntita
      },
      {
        path: '/myAccount',
        name: "MyAccount",
        component: MyAccount,
        meta:{
          breadCrumbs:[
            {
              to: '/default',
              text: 'Home'
            },
            {
              to: '',
              text: 'MyAccount'
            }
          ]
        }
      },
      {
        path: '/contratti',
        name: "Contratti",
        component: Contratti,   
        meta: {
          breadCrumbs:[
            {
              to: '/default',
              text: 'Home'
            },
            {
              to: '',
              text: 'Contratti'
            }
          ]
        } 
      },
    ]
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
